import React, { useState } from 'react';

import './PrivacyPolicy.css';
import img1 from '../../assets/images/PrivacyPolicy/1 Introduction.png';
import img2 from '../../assets/images/PrivacyPolicy/2 Personal Information We Collect.png';
import img2_1 from '../../assets/images/PrivacyPolicy/2.1 Personal Information You Provide to Us.png';
import img2_2 from '../../assets/images/PrivacyPolicy/2.2 Personal Information We Collect When You Use Our Services.png';
import img2_2_1 from '../../assets/images/PrivacyPolicy/2.2.1 Strictly Necessary Cookies.png';
import img2_2_2 from '../../assets/images/PrivacyPolicy/2.2.2 Functional Cookies.png';
import img2_2_3 from '../../assets/images/PrivacyPolicy/2.2.3 Analytical or Performance Cookies.png';
import img2_2_4 from '../../assets/images/PrivacyPolicy/2.2.4 Advertising Cookies.png';
import img2_3 from '../../assets/images/PrivacyPolicy/2.3 Personal Information We Receive from Other Sources.png';
import img3 from '../../assets/images/PrivacyPolicy/3 How We Use the Personal Information We Collect.png';
import img4 from '../../assets/images/PrivacyPolicy/4 Legal Bases for Processing European Personal Information.png';
import img5_1 from '../../assets/images/PrivacyPolicy/5.1 How We Disclose the Personal Information We Collect.png';
import img5_2 from '../../assets/images/PrivacyPolicy/5.2 How We Disclose the Personal Information We Collect.png';
import img6_1 from '../../assets/images/PrivacyPolicy/6.1 Your Rights and Choices.png';
import img6_2 from '../../assets/images/PrivacyPolicy/6.2 Your Rights and Choices.png';
import img7 from '../../assets/images/PrivacyPolicy/7 Third Parties.png';
import img8 from '../../assets/images/PrivacyPolicy/8 Retention.png';
import img9 from '../../assets/images/PrivacyPolicy/9 Security.png';
import img10 from '../../assets/images/PrivacyPolicy/10 Children’s Privacy.png';
import img11 from '../../assets/images/PrivacyPolicy/11 International Visitors.png';
import img12 from '../../assets/images/PrivacyPolicy/12 Update Your Personal Information.png';
import img13 from '../../assets/images/PrivacyPolicy/13 Changes to this Privacy Policy.png';
import img14 from '../../assets/images/PrivacyPolicy/14 Contact Information.png';

const privacyPolicyData = [
    {
        title: '1. Introduction',
        content: img1,
        accessibleLinks: [
            'https://www.grantaide.com/',
            'https://www.collectit.io/',
            'https://www.grantaide.com/termsofservice',
        ],
        subsections: [],
    },
    {
        title: '2. Personal Information We Collect',
        content: img2,
        subsections: [
            { title: '2.1. Information You Provide to Us', content: img2_1 },
            {
                title: '2.2. Information We Collect When You Use Our Services',
                content: [img2_2, img2_2_1, img2_2_2, img2_2_3, img2_2_4],
                accessibleLinks: [
                    'https://policies.google.com/privacy?hl=en',
                ],
            },
            { title: '2.3. Information We Receive from Other Sources', content: img2_3 },
        ],
    },
    {
        title: '3. How We Use the Personal Information We Collect',
        content: img3,
        subsections: [],
    },
    {
        title: '4. Legal Bases for Processing European Personal Information',
        content: img4,
        subsections: [],
    },
    {
        title: '5. How We Disclose the Personal Information We Collect',
        content: [img5_1, img5_2],
        accessibleLinks: [
            'https://www.google.com/policies/privacy/partners/',
            'https://tools.google.com/dlpage/gaoptout?hl=en',
            'https://optout.networkadvertising.org',
            'https://optout.aboutads.info',
        ],
        subsections: [],
    },
    {
        title: '6. Your Rights and Choices',
        content: [img6_1, img6_2],
        subsections: [],
    },
    {
        title: '7. Third Parties',
        content: img7,
        subsections: [],
    },
    {
        title: '8. Retention',
        content: img8,
        subsections: [],
    },
    {
        title: '9. Security',
        content: img9,
        subsections: [],
    },
    {
        title: "10. Children's Privacy",
        content: img10,
        subsections: [],
    },
    {
        title: '11. International Visitors',
        content: img11,
        subsections: [],
    },
    {
        title: '12. Update Your Personal Information',
        content: img12,
        subsections: [],
    },
    {
        title: '13. Changes to this Privacy Policy',
        content: img13,
        subsections: [],
    },
    {
        title: '14. Contact Information',
        content: img14,
        subsections: [],
    },
];

function PrivacyPolicy() {
    const [expandedSections, setExpandedSections] = useState({});
    const [expandedSubsections, setExpandedSubsections] = useState({});

    const toggleSection = (section) => {
        setExpandedSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    const toggleSubsection = (section, subsection) => {
        setExpandedSubsections((prev) => ({
            ...prev,
            [`${section}-${subsection}`]: !prev[`${section}-${subsection}`],
        }));
    };

    return (
        <div className='terms-page privacy-policy-page'>
            <div className="terms-container">
                <h1 className="terms-heading">Privacy Policy</h1>
                {privacyPolicyData.map((section, sectionIndex) => (
                    <div className="terms-section" key={sectionIndex}>
                        <div
                            className="terms-subheading"
                            onClick={() => toggleSection(sectionIndex)}
                        >
                            <span>{section.title}</span>
                            <span className="symbol">{expandedSections[sectionIndex] ? "−" : "+"}</span>
                        </div>
                        {expandedSections[sectionIndex] && (
                            <div>
                                {(Array.isArray(section.content) ? section.content : [section.content]).map((image, imageIndex) => (
                                    <img className="privacy-policy-image" key={imageIndex} src={image} alt="" />
                                ))}
                                {section.accessibleLinks && (
                                    <div className="privacy-policy-accessible-links">
                                        <div>Accessible Links:</div>
                                        {section.accessibleLinks.map((url) => (
                                            <a key={url} href={url} target="_blank" rel="noopener noreferrer">
                                                {url}
                                            </a>
                                        ))}
                                    </div>
                                )}
                                {section.subsections.map((subsection, subsectionIndex) => (
                                    <div key={subsectionIndex} className="ml-5">
                                        <div
                                            className="terms-subsection-heading"
                                            onClick={() => toggleSubsection(sectionIndex, subsectionIndex)}
                                        >
                                            <span>{subsection.title}</span>
                                            <span className="symbol">{expandedSubsections[`${sectionIndex}-${subsectionIndex}`] ? "−" : "+"}</span>
                                        </div>
                                        {expandedSubsections[`${sectionIndex}-${subsectionIndex}`] && (
                                            <div>
                                                {(Array.isArray(subsection.content) ? subsection.content : [subsection.content]).map((image, imageIndex) => (
                                                    <img className="privacy-policy-image" key={imageIndex} src={image} alt="" />
                                                ))}
                                                {subsection.accessibleLinks && (
                                                    <div className="privacy-policy-accessible-links">
                                                        <div>Accessible Links:</div>
                                                        {subsection.accessibleLinks.map((url) => (
                                                            <a key={url} href={url} target="_blank" rel="noopener noreferrer">
                                                                {url}
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PrivacyPolicy;
